import * as TabsPrimitive from '@radix-ui/react-tabs'

import {
  AddressSearchTabId,
  AddressSearchTabItem,
} from '~/components/component-library/AddressSearchInput/types'
import { TabsList, TabsTrigger } from '~/components/component-library/Tabs'

type AddressSearchTabsProps = {
  tabs: AddressSearchTabItem[]
  activeTab: AddressSearchTabId
  onTabChange: (tab: AddressSearchTabId) => void
}

export const AddressSearchTabs = ({
  tabs,
  activeTab,
  onTabChange,
}: AddressSearchTabsProps) => (
  <TabsPrimitive.Root value={activeTab}>
    <TabsList className="gap-1 space-x-0 border-b-0 px-1">
      {tabs.map(({ id, label }) => (
        <TabsTrigger
          key={id}
          value={id}
          // Focus stays in the search input; clicking a tab must not blur it.
          tabIndex={-1}
          onMouseDown={(e) => e.preventDefault()}
          onClick={() => onTabChange(id)}
          className="!mb-0 flex-shrink-0 px-2 py-1.5 text-sm font-normal"
        >
          {label}
        </TabsTrigger>
      ))}
    </TabsList>
    <div className="-mt-px border-b border-gray-200 dark:border-gray-700" />
  </TabsPrimitive.Root>
)

AddressSearchTabs.displayName = 'AddressSearchTabs'
